import React from "react";
import ReactMarkdown from "react-markdown";
import { Accordion, AccordionDetails, AccordionSummary, Typography, styled } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import KeyValueListTable from "../../../components/common/KeyValueListTable";
import { GeneralTaskPageQuery$data } from "../__generated__/GeneralTaskPageQuery.graphql";
import { SweepArguments } from "../generalTask.types";
import { formatDate } from "../../../utils/utils";

interface GeneralTaskDetailTabProps {
  data: GeneralTaskPageQuery$data;
  sweepArgs: SweepArguments;
}

const InfoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: theme.spacing(1),
  flexFlow: "row wrap",
  gap: "1rem",
}));

const GeneralTaskDetailTab: React.FC<GeneralTaskDetailTabProps> = ({ data, sweepArgs }: GeneralTaskDetailTabProps) => {
  const createdDate = formatDate(data?.node?.created as string);
  const updatedDate = formatDate(data?.node?.updated as string);

  return (
    <>
      <InfoContainer>
        <Typography>
          <strong>Model type:</strong> {data?.node?.model_type}
        </Typography>
        <Typography>
          <strong>Subtask type:</strong> {data?.node?.subtask_type}
        </Typography>
        <Typography>
          <strong>Subtask result:</strong> {data?.node?.subtask_result}
        </Typography>
        <Typography>
          <strong>Subtask count:</strong> {data?.node?.subtask_count}
        </Typography>
        <Typography>
          <strong>Agent name: </strong> {data?.node?.agent_name}
        </Typography>
        <Typography>
          <strong>Created: </strong> {createdDate}
        </Typography>
        {updatedDate && (
          <Typography>
            <strong>Updated: </strong> {updatedDate}
          </Typography>
        )}
      </InfoContainer>
      <InfoContainer>
        <Typography>
          <strong>Description:</strong>
        </Typography>
        <Typography>{data?.node?.description ?? ""}</Typography>
      </InfoContainer>
      {data?.node?.notes && (
        <span>
          <Typography>
            <strong>Notes:</strong>
          </Typography>
          <ReactMarkdown>{data?.node?.notes}</ReactMarkdown>
        </span>
      )}
      <Accordion defaultExpanded={sweepArgs.length > 0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>
            <strong>Swept Arguments</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {data?.node?.argument_lists && <KeyValueListTable header={null} data={sweepArgs} />}
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>
            <strong>All Arguments</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {data?.node?.argument_lists && <KeyValueListTable header={null} data={data?.node?.argument_lists} />}
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default GeneralTaskDetailTab;
